export default __webpack_public_path__ + "static/media/banner4.58f9a7a2.png";